let gmapAddressComponentMapping = {
  street_number: {
    field: 'address',
    separator: ' '
  },
  route: {
    field: 'address',
    separator: ''
  },
  postal_code: {
    field: 'zipCode',
    separator: ''
  },
  locality: {
    field: 'city',
    separator: ''
  }
}

export function formatAddress (place) {

  const address = {
    address: '',
    zipCode: '',
    city: ''
  }

  place.address_components.forEach(element => {
    element.types.forEach(type => {
      if (Object.prototype.hasOwnProperty.call(gmapAddressComponentMapping, type)) {
        const mapping = gmapAddressComponentMapping[type]
        if (element.long_name) {
          address[mapping.field] += element.long_name
        }
        if (mapping.separator) {
          address[mapping.field] += mapping.separator
        }
      }
    })
  })

  return address
}

export function addressToString (address) {
  if (address.address !== '' && address.zipCode !== '' && address.city !== '' ) {
    return `${address.address}, ${address.zipCode} ${address.city}`
  }

  return '';
}